import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M38.3 34.6c-1 0-1.9.3-2.7.7L30 29l-1.9 1.7 5.5 6.3c-.7.9-1.1 2.1-1.1 3.4 0 3.2 2.6 5.7 5.7 5.7 3.2 0 5.7-2.6 5.7-5.7.1-3.3-2.5-5.8-5.6-5.8zm0 8.9c-1.8 0-3.2-1.4-3.2-3.2 0-1.8 1.5-3.2 3.2-3.2 1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.5 3.2-3.2 3.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M44.1 19.8c-.8-.5-1.6-.8-2.5-.8-1.4 0-2.8.7-3.7 1.9-.3.4-.4.8-.6 1.2h-5.4v2.5h5.4c.3.9.8 1.8 1.7 2.4.8.5 1.6.8 2.5.8 1.4 0 2.8-.7 3.7-1.9 1.4-1.9.9-4.7-1.1-6.1zm-.9 4.8c-.4.5-1 .8-1.6.8-.4 0-.8-.1-1.1-.3-.9-.6-1.1-1.8-.5-2.7.4-.5 1-.8 1.6-.8.4 0 .8.1 1.1.3.4.3.7.7.8 1.2 0 .6 0 1.1-.3 1.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M26 1.8c-.8-.6-1.6-.8-2.5-.8-1.4 0-2.8.7-3.7 1.9C18.5 5 19 7.7 21 9.1c.4.3.8.5 1.3.6v5.4h2.5V9.7c.9-.3 1.8-.9 2.4-1.7 1.3-2.1.8-4.8-1.2-6.2zm-.9 4.7c-.4.5-1 .8-1.6.8-.4 0-.8-.1-1.1-.3-.9-.6-1.1-1.8-.5-2.7.4-.5 1-.8 1.6-.8.4 0 .8.1 1.1.3.4.3.7.7.8 1.2.1.6 0 1.1-.3 1.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M16.7 28.6l-1.1-2.2-6.7 3.4c-.3-.3-.5-.6-.9-.8-.8-.5-1.6-.8-2.5-.8-1.4 0-2.8.7-3.7 1.9-1.4 2-.9 4.8 1.1 6.2.8.5 1.7.7 2.5.7 1.4 0 2.8-.7 3.7-1.9.6-.9.8-2 .7-3l6.9-3.5zM7 33.7c-.4.5-1 .8-1.6.8-.4 0-.8-.1-1.1-.3-.4-.3-.7-.7-.8-1.2-.1-.5 0-1 .3-1.5.4-.5 1-.8 1.6-.8.4 0 .8.1 1.1.3.9.6 1.1 1.8.5 2.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M23.5 33.2c-5.3 0-9.6-4.3-9.6-9.7 0-5.3 4.3-9.6 9.6-9.6s9.7 4.3 9.7 9.6-4.4 9.7-9.7 9.7zm0-16.8c-3.9 0-7.1 3.2-7.1 7.1s3.2 7.2 7.1 7.2 7.2-3.2 7.2-7.2-3.3-7.1-7.2-7.1z"
		})
	]
});
export default SvgIcon;
